export const environment = {
    env : "development",
    Production: false,
    DefaultLanguageCode: "en-US", 
    DefaultCurrencyCode: "MYR", 
    TokenKeys: {
        // Local Storage
        AccessToken: 'accesstoken',
        RefreshToken: "refreshtoken",
        Language: "language",
        WebType: "webtype",
        Domain: "domain",
        MerchantCode: "merchantcode",
        MerchantId: "merchantid",
        UserInfo: "userinfo",
        MenuList: "menulist",
        ActiveRoute: "activeroute",
        Favicon: "favicon",
        Currency: "currency",
        CurrencyList: "currencylist",

        // Session Storage
        ThemeCssToken: "themecss",
        RedirectUrl: "redirecturl"
    },
    ApiConfig: {
        SystemUrl: 'https://dev-wl000-v1-api-bo-system-c3bpgbeqgbbxdfb7.southeastasia-01.azurewebsites.net',
        MerchantUrl: 'https://dev-wl000-v1-api-bo-merchant-e5ckdmcjewe9e6bv.southeastasia-01.azurewebsites.net',
        AdminUrl: 'https://dev-wl000-v1-api-bo-admin-gffzh4bmb3cpa9ae.southeastasia-01.azurewebsites.net',
        AuthUrl: 'https://dev-wl000-v1-api-bo-authenticate-f5cyechncpajbtex.southeastasia-01.azurewebsites.net',
        ContentUrl: 'https://dev-wl000-v1-api-bo-content-gucnddg7a9d9arcz.southeastasia-01.azurewebsites.net',
        UnAgentUrl: 'https://dev-wl000-v1-api-bo-agent-unlimited-dud8guakcuaba3b5.southeastasia-01.azurewebsites.net',
        MemberUrl: 'https://dev-wl000-v1-api-bo-member-unlimited-eph0hkfbe3cmaueq.southeastasia-01.azurewebsites.net',
        AwcGameUrl: 'https://dev-wl000-v1-api-bo-game-awc-hafbbrdabafva8bh.southeastasia-01.azurewebsites.net',
        Win16GameUrl: 'https://dev-wl000-v1-api-bo-game-win16-e9fcfqa7f4h8h6f5.southeastasia-01.azurewebsites.net',
        PublicUrl: 'https://dev-wl000-v1-api-bo-public-eadqanaqgeazhkht.southeastasia-01.azurewebsites.net',
        Timeout: 10000 //10sec
    },
    NoImageUrl: 'https://devwl000api01storage.blob.core.windows.net/test/no-image.jpg',
    Listing: {
        size: [5, 10, 20, 30, 50],
        default: 10
    }
};
